import { AxiosResponse } from "axios";
import { ConfiguracaoPessoaDTO, IAbstractEnum, IAbstractModel } from "model/abstract.model";
import LoginService from "pages/login/login.service";
import { axiosRequest } from "../../axios/axios.config";
import { Endereco, PessoaTO } from "./pessoa.model";
import { TipoPessoa } from "model/cliente.model";

export const CadastroPessoaService = () => {
    const path = '/pessoa';
    const loginService = LoginService();

    const getEnumAC = (enumname: string) => {
        return axiosRequest.get(`${path}/acenum/${enumname}`, { headers: loginService.getHeaders() });
    };

    return {
        getTipoPessoaAC(): Promise<AxiosResponse<Array<IAbstractEnum>>> {
            return getEnumAC('TipoPessoa');
        },
        getPapelAC(): Promise<AxiosResponse<Array<IAbstractEnum>>> {
            return getEnumAC('Papel');
        },
        getTipoContribuinte(): Promise<AxiosResponse<Array<IAbstractEnum>>> {
            return getEnumAC('TipoContribuinte');
        },
        getMunicipios(toSearch: string): Promise<AxiosResponse<any>> {
            const nQuery = {
                first: 0,
                pageSize: 50,
                status: "A",
                isAdvanced: true,
                advancedNQuery: {
                    logicalOperator: "OR",
                    alias: "obj",
                    subQuerys: [
                        {
                            logicalOperator: "SIMPLE",
                            criteria: {
                                field: "nome",
                                comparisonOperator: "CONTAINS",
                                value: toSearch,
                                fieldFn: "to_char(obj.nome)"
                            },
                            alias: null
                        },
                        {
                            logicalOperator: "SIMPLE",
                            criteria: {
                                field: "uf",
                                comparisonOperator: "CONTAINS",
                                value: toSearch,
                                fieldFn: "to_char(obj.uf)"
                            },
                            alias: null
                        }
                    ]
                },
                fieldsToSimpleMatch: [],
                simpleMatch: "",
                orderBy: "nome ASC"
            };
            return axiosRequest.post('/municipio/acdescritivo', nQuery, { headers: loginService.getHeaders() });
        },

        listPais(): Promise<AxiosResponse<any>> {
            return axiosRequest.get('/municipio/pais', { headers: loginService.getHeaders() });
        },

        saveMunicipio(payload: { nome: string, pais: IAbstractModel }): Promise<AxiosResponse<any>> {
            return axiosRequest.post('/municipio/', payload, { headers: loginService.getHeaders() });
        },

        findCep(cep: string): Promise<AxiosResponse<{ endereco: Endereco, municipio: IAbstractModel; }>> {
            return axiosRequest.get(`/endereco/cep/${cep}`, { headers: loginService.getHeaders() });
        },
        searchCnpj(cnpj: string): Promise<AxiosResponse<PessoaTO>> {
            return axiosRequest.get(`${path}/cnpj/${cnpj}`, { headers: loginService.getHeaders() });
        },
        getExistidentification(identify: string): Promise<AxiosResponse<boolean>> {
            return axiosRequest.get(`${path}/existecpfcnpj/${identify}`, { headers: loginService.getHeaders() });
        },
        save(pessoa: PessoaTO): Promise<AxiosResponse<PessoaTO>> {
            return axiosRequest.put(`${path}`, pessoa, { headers: loginService.getHeaders() });
        },
        getPessoa(uuid: string): Promise<AxiosResponse<PessoaTO>> {
            return axiosRequest.get(`${path}/${uuid}`, {
                headers: loginService.getHeaders(),
                params: {
                    listarPreferenciasApenasEstabelecimento: true
                }
            });
        },
        getConfiguracaoPessoa(): Promise<AxiosResponse<Array<ConfiguracaoPessoaDTO>>> {
            return axiosRequest.get(`configuracoes${path}`, { headers: loginService.getHeaders() })
        },
        getFormasComissaoPessoa(uuidPessoa: string): Promise<AxiosResponse<Array<IAbstractModel>>> {
            return axiosRequest.get(`${path}/descritivo/formacomissao/list`, { headers: loginService.getHeaders() })
        },
        getRepresentantes(uuids: string): Promise<AxiosResponse<Array<any>>> {
            return axiosRequest.get(`${path}/descritivo/representante`, { headers: loginService.getHeaders(), params: { uuids } })
        },
        getGuias(uuids: string): Promise<AxiosResponse<Array<any>>> {
            return axiosRequest.get(`${path}/descritivo/guia`, { headers: loginService.getHeaders(), params: { uuids } })
        },
        getTipoPessoaPadrao(): Promise<AxiosResponse<TipoPessoa>> {
            return axiosRequest.get(`${path}/tipo-pessoa-padrao`, { headers: loginService.getHeaders() })
        },
        updateTipoPessoaPadrao(tipoPessoa: string): Promise<AxiosResponse<TipoPessoa>> {
            return axiosRequest.put(`${path}/tipo-pessoa-padrao/${tipoPessoa}`, null, { headers: loginService.getHeaders() })
        },
        vincularEstabelecimento(uuids: string[]): Promise<AxiosResponse<void>> {
            return axiosRequest.post(`${path}/vincular-estabelecimento`, uuids, { headers: loginService.getHeaders() });
        }
    };
};
